export default __webpack_public_path__ + "static/media/mapa.cf698a78.svg";